import Vue from "vue";
import VueRouter from "vue-router";

import state from "@/state";

import Home from "@/views/Home.vue";

import BdrFws_1d00_rc1 from "@/device-simulations/BdrFws_1d00_rc1.vue";
import BdrFws_1d01_P10 from "@/device-simulations/BdrFws_1d01_P10.vue";
import BdrFws_1d01_P20 from "@/device-simulations/BdrFws_1d01_P20.vue";
import BdrFws_1d01_P30 from "@/device-simulations/BdrFws_1d01_P30.vue";
import BdrFws_1d02_P20 from "@/device-simulations/BdrFws_1d02_P20.vue";
import BdrFws_1d01_Kaskade_P20 from "@/device-simulations/BdrFws_1d01_Kaskade_P20.vue";
import BdrFws_1d01_Kaskade_P30 from "@/device-simulations/BdrFws_1d01_Kaskade_P30.vue";
import BdrFws_1d02_Kaskade_P20 from "@/device-simulations/BdrFws_1d02_Kaskade_P20.vue";
import ResolFwr_1d00_p40 from "@/device-simulations/ResolFwr_1d00_p40.vue";

import CitrinSlrXt2_1d00 from "@/device-simulations/CitrinSlrXt2_1d00.vue";
// import Novasfer_HIU_2d00_P10 from '@/device-simulations/Novasfer_HIU_2d00_P10.vue';
// import ResolHIU_2d00_P10 from '@/device-simulations/ResolHIU_2d00_P10.vue';
import ResolHIU_2d00_P110 from "@/device-simulations/ResolHIUMini_2d00_P110.vue";

import CosmoMulti3_1d00 from "@/device-simulations/CosmoMulti3_1d00.vue";

import FchHc_1d02 from "@/device-simulations/FchHc_1d02.vue";

// import HrSolarHeatPump2020_1d0d0 from '@/device-products/HrSolarHeatPump2020_1d0d0.vue';

import KemperFwrLima_1d00 from "@/device-simulations/KemperFwrLima_1d00.vue";
import KemperFwrLima_1d00_Kaskade from "@/device-simulations/KemperFwrLima_1d00_Kaskade.vue";

import ViessmannVitotrans353_VT2_2d00 from "@/device-simulations/ViessmannVitotrans353VT2_2d00.vue";
import ViessmannVitotrans353_VT2_2d00_Kaskade from "@/device-simulations/ViessmannVitotrans353VT2_2d00_Kaskade.vue";

// import WMZPlus_1d06 from '@/device-simulations/WMZPlus_1d06.vue';
import ResolDeltaSolBs4_1d03 from "@/device-simulations/ResolDeltaSolBs4_1d03.vue";
import ResolDeltaSolBx_4d00 from "@/device-simulations/ResolDeltaSolBx_4d00.vue";
import ResolDeltaSolBxPlus_2d10 from "@/device-simulations/ResolDeltaSolBxPlus_2d10.vue";
import ResolDeltaSolCsPlus_2d00 from "@/device-simulations/ResolDeltaSolCsPlus_2d00.vue";
import ResolDeltaSolMx_2d11 from "@/device-simulations/ResolDeltaSolMx_2d11.vue";
import ResolDeltaSolMx_3_1d00 from "@/device-simulations/ResolDeltaSolMx_3_1d00.vue";
import ResolDeltaSolMxPlus_1d00 from "@/device-simulations/ResolDeltaSolMxPlus_1d00.vue";
import ResolDeltaSolSl_1d06 from "@/device-simulations/ResolDeltaSolSl_1d06.vue";
import ResolDeltaSolSl_3d02 from "@/device-simulations/ResolDeltaSolSl_3d02.vue";
import ResolDeltaSolSL_Calpak_1d00 from "@/device-simulations/ResolDeltaSolSL_Calpak_1d00.vue";
import ResolDeltaSolSL_Calpak_1d01 from "@/device-simulations/ResolDeltaSolSL_Calpak_1d01.vue";
import ResolDeltaSolSll_2d00 from "@/device-simulations/ResolDeltaSolSll_2d00.vue";
import ResolDeltaSolSll_5d01 from "@/device-simulations/ResolDeltaSolSll_5d01.vue";
import ResolDeltaSolSll_6_1d00 from "@/device-simulations/ResolDeltaSolSll_6_1d00.vue";
import EnvirosunDeltaSolSll_1d00 from "@/device-simulations/EnvirosunDeltaSolSll_1d00.vue";
import DUXDeltaSolSll_1d00 from "@/device-simulations/DUXDeltaSolSll_1d00.vue";
import SolarControllersAustraliaDeltaSolSll_1d00_P10 from "@/device-simulations/SolarControllersAustraliaDeltaSolSll_1d00_P10.vue";
import SolarControllersAustraliaDeltaSolSll_1d00_P20 from "@/device-simulations/SolarControllersAustraliaDeltaSolSll_1d00_P20.vue";
import ApricusDeltaSolSll_1d00 from "@/device-simulations/ApricusDeltaSolSll_1d00.vue";
import ResolDeltaSolSlt_1d05 from "@/device-simulations/ResolDeltaSolSlt_1d05.vue";
import ResolDeltaSolSlt_2d02 from "@/device-simulations/ResolDeltaSolSlt_2d02.vue";
import ResolDeltaSolSlt_2d03 from "@/device-simulations/ResolDeltaSolSlt_2d03.vue";
import SeconDeltaSolSlt_1d00 from "@/device-simulations/SeconDeltaSolSlt_1d00.vue";
import SeconDeltaSolSlt_1d00_P31 from "@/device-simulations/SeconDeltaSolSlt_1d00_P31.vue";
import ResolDeltaSolTt_2d00 from "@/device-simulations/ResolDeltaSolTt_2d00.vue";
import ResolDeltaThermFk_1d10 from "@/device-simulations/ResolDeltaThermFk_1d10.vue";
import ResolDeltaThermHc_1d23 from "@/device-simulations/ResolDeltaThermHc_1d23.vue";
import ResolDeltaThermHcMini_1d02 from "@/device-simulations/ResolDeltaThermHcMini_1d02.vue";
import ResolDeltaThermHcMini2_2d00 from "@/device-simulations/ResolDeltaThermHcMini2_2d00.vue";
import ResolDeltaThermHcPlus_1d00 from "@/device-simulations/ResolDeltaThermHcPlus_1d00.vue";
import ResolDeltaThermPhm_1d01 from "@/device-simulations/ResolDeltaThermPhm_1d01.vue";
import ResolDeltaThermPv_1d04 from "@/device-simulations/ResolDeltaThermPv_1d04.vue";
import ResolFwr2018_2d00_P160 from "@/device-simulations/ResolFwr2018_2d00_P160.vue";
import ResolDeltaSolFreshVFS_1d00_P10 from '@/device-simulations/ResolDeltaSolFreshVFS_1d00_P10.vue';
import ResolTt2_1d01 from "@/device-simulations/ResolTt2_1d01.vue";
import Waterkotte_EcoPack_2d02 from "@/device-simulations/Waterkotte_EcoPack_2d02.vue";
import ResolDeltaThermPvm_1d02 from "@/device-simulations/ResolDeltaThermPvm_1d02.vue";
import ResolDeltaThermPvm_1d03_P30 from "@/device-simulations/ResolDeltaThermPvm_1d03_P30.vue";
import ResolDeltaThermPvm_1d03_P40 from "@/device-simulations/ResolDeltaThermPvm_1d03_P40.vue";
import ResolDeltaThermPvm_1d03_P50 from "@/device-simulations/ResolDeltaThermPvm_1d03_P50.vue";
import ResolDeltaThermPvm_1d03_P60 from "@/device-simulations/ResolDeltaThermPvm_1d03_P60.vue";
import ResolDeltaThermPvm_1d03_P70 from "@/device-simulations/ResolDeltaThermPvm_1d03_P70.vue";
import ResolDeltaThermPvm_1d03_P80 from "@/device-simulations/ResolDeltaThermPvm_1d03_P80.vue";
import ResolDeltaThermPvm_1d03 from "@/device-simulations/ResolDeltaThermPvm_1d03.vue";
import ResolDeltaThermPvm_1d11_P40 from "@/device-simulations/ResolDeltaThermPvm_1d11_P40.vue";
import ResolDeltaThermHiuMini_2d00 from "@/device-simulations/ResolDeltaThermHiuMini_2d00.vue";

import TuxhornEthermP_4d00 from "@/device-simulations/TuxhornEthermP_4d00.vue";
import TuxhornEThermP9Plus_1d02 from "@/device-simulations/TuxhornEThermP9Plus_1d02.vue";
import TuxhornEThermP9Plus_1d03_P30 from "@/device-simulations/TuxhornEThermP9Plus_1d03_P30.vue";
import TuxhornEThermP9Plus_1d03_P50 from "@/device-simulations/TuxhornEThermP9Plus_1d03_P50.vue";
import TuxhornEThermP9Plus_1d03_P60 from "@/device-simulations/TuxhornEThermP9Plus_1d03_P60.vue";
import TuxhornEThermP9Plus_1d03_P70 from "@/device-simulations/TuxhornEThermP9Plus_1d03_P70.vue";
import TuxhornEThermP9Plus_1d03_P80 from "@/device-simulations/TuxhornEThermP9Plus_1d03_P80.vue";
import TuxhornEThermP9Plus_1d03 from "@/device-simulations/TuxhornEThermP9Plus_1d03.vue";
import TuxhornEThermP9Plus_1d11_P40 from "@/device-simulations/TuxhornEThermP9Plus_1d11_P40.vue";
import Tuxhorn_Nemux_SML_V2_3d04 from "@/device-simulations/Tuxhorn_Nemux_SML_V2_3d04.vue";
import Tuxhorn_Nemux_SML_V2_3d05 from "@/device-simulations/Tuxhorn_Nemux_SML_V2_3d05.vue";
import Tuxhorn_Nemux_SML_V2_3d06_P20 from "@/device-simulations/Tuxhorn_Nemux_SML_V2_3d06_P20.vue";
import Citrin_CS1_3_1d03 from "@/device-simulations/Citrin_CS1_3_1d03";
import ResolDeltaSol_CSPlus_3d00 from "@/device-simulations/ResolDeltaSol_CSPlus_3d00.vue";
import MaxiflameMaxifresh_1d02_P11 from "@/device-simulations/MaxiflameMaxifresh_1d02_P11.vue";
import MaxiflameMaxifresh_1d02_P20 from "@/device-simulations/MaxiflameMaxifresh_1d02_P20.vue";
import MaxiflameMaxifresh_1d02_P30 from "@/device-simulations/MaxiflameMaxifresh_1d02_P30.vue";
import MaxiflameMaxifresh_1d02_P40 from "@/device-simulations/MaxiflameMaxifresh_1d02_P40.vue";
import MaxiflameMaxifresh_1d02_P50 from "@/device-simulations/MaxiflameMaxifresh_1d02_P50.vue";
import MaxiflameMaxifresh_1d02_P60 from "@/device-simulations/MaxiflameMaxifresh_1d02_P60.vue";
import MaxiflameMaxifresh_1d02_P70 from "@/device-simulations/MaxiflameMaxifresh_1d02_P70.vue";

function runAsyncGuard(next, fn) {
  async function runner() {
    return await fn();
  }

  runner().then(
    (result) => {
      if (result !== undefined) {
        next(result);
      } else {
        next();
      }
    },
    (err) => {
      global.console.error(err);
      next("/");
    },
  );
}

function processInvite(to, from, next) {
  runAsyncGuard(next, async () => {
    await state.simulationsPromise;

    try {
      const { token } = to.params;

      const simulations = await state.performJsonRpc("getSimulationsByToken", {
        token: token.replace(/--.*$/, ""),
      });

      state.token = token;
      state.simulations = simulations;

      localStorage.setItem("de.resol.web-simulation.token", token);
    } catch (err) {
      global.console.error(err);
    }

    return "/";
  });
}

function checkValidSimulationRoute(to, from, next) {
  runAsyncGuard(next, async () => {
    await state.simulationsPromise;

    const simulation = state.simulations.find((sim) => sim.to === to.path);
    if (!simulation) {
      return "/";
    }
  });
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/invite/:token",
    beforeEnter: processInvite,
  },
  {
    path: "/ResolHIUMini_2d00_P110",
    component: ResolHIU_2d00_P110,
    beforeEnter: checkValidSimulationRoute,
  },
  //   {
  //     path: '/novasfer-hiu',
  //     component: Novasfer_HIU_2d00_P10,
  //     beforeEnter: checkValidSimulationRoute,
  //   },
  // {
  //   path: '/wmz-plus',
  //   component: WMZPlus_1d06,
  //   beforeEnter: checkValidSimulationRoute,
  // },
  {
    path: "/bdr-fws-1d00-rc1",
    component: BdrFws_1d00_rc1,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d01-p10",
    component: BdrFws_1d01_P10,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d01-p20",
    component: BdrFws_1d01_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d01-p30",
    component: BdrFws_1d01_P30,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d02-p20",
    component: BdrFws_1d02_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d01-kaskade-p20",
    component: BdrFws_1d01_Kaskade_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d01-kaskade-p30",
    component: BdrFws_1d01_Kaskade_P30,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/bdr-fws-1d02-kaskade-p20",
    component: BdrFws_1d02_Kaskade_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-fwr-1d00-p40",
    component: ResolFwr_1d00_p40,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/citrin-slr-xt-2",
    component: CitrinSlrXt2_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/cosmo-multi3",
    component: CosmoMulti3_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/fch-hc",
    component: FchHc_1d02,
    beforeEnter: checkValidSimulationRoute,
  },
  // {
  //   path: '/hr-solar',
  //   name: 'HrSolarHeatPump2020_1.0.0',
  //   component: HrSolarHeatPump2020_1d0d0,
  //   beforeEnter: checkValidSimulationRoute,
  // },
  {
    path: "/kemper-lima",
    component: KemperFwrLima_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/kemper-lima-kaskade",
    component: KemperFwrLima_1d00_Kaskade,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-bs-4",
    component: ResolDeltaSolBs4_1d03,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-cs-plus",
    component: ResolDeltaSolCsPlus_2d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-mx-3",
    component: ResolDeltaSolMx_3_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-mx",
    component: ResolDeltaSolMx_2d11,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-mx-plus",
    component: ResolDeltaSolMxPlus_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-bx",
    component: ResolDeltaSolBx_4d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-bx-plus",
    component: ResolDeltaSolBxPlus_2d10,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-tt",
    component: ResolDeltaSolTt_2d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sl",
    component: ResolDeltaSolSl_1d06,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sl-3",
    component: ResolDeltaSolSl_3d02,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sl-calpak-1.00",
    component: ResolDeltaSolSL_Calpak_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sl-calpak-1.01",
    component: ResolDeltaSolSL_Calpak_1d01,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sll",
    component: ResolDeltaSolSll_2d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sll-6-1.00",
    component: ResolDeltaSolSll_6_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-sll-5.01",
    component: ResolDeltaSolSll_5d01,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/DUX-deltasol-sll-1.00",
    component: DUXDeltaSolSll_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/SolarControllersAustralia-deltasol-sll-1d00-P10",
    component: SolarControllersAustraliaDeltaSolSll_1d00_P10,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/SolarControllersAustralia-deltasol-sll-1d00-P20",
    component: SolarControllersAustraliaDeltaSolSll_1d00_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/Apricus-deltasol-sll-1.00",
    component: ApricusDeltaSolSll_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/envirosun-deltasol-sll-1.00",
    component: EnvirosunDeltaSolSll_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-slt",
    component: ResolDeltaSolSlt_1d05,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-slt-v2",
    component: ResolDeltaSolSlt_2d02,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-slt-v2d03",
    component: ResolDeltaSolSlt_2d03,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/secon-deltasol-slt-v1d00",
    component: SeconDeltaSolSlt_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/secon-deltasol-slt-v1d00-P31",
    component: SeconDeltaSolSlt_1d00_P31,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-fk",
    component: ResolDeltaThermFk_1d10,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-hc",
    component: ResolDeltaThermHc_1d23,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-hc-mini",
    component: ResolDeltaThermHcMini_1d02,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-hc-mini-2",
    component: ResolDeltaThermHcMini2_2d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-hc-plus",
    component: ResolDeltaThermHcPlus_1d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: '/resol-deltatherm-hiu-mini',
    component: ResolDeltaThermHiuMini_2d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: '/resol-deltatherm-phm',
    component: ResolDeltaThermPhm_1d01,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pv",
    component: ResolDeltaThermPv_1d04,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d02",
    component: ResolDeltaThermPvm_1d02,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d03-P30",
    component: ResolDeltaThermPvm_1d03_P30,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d03-P40",
    component: ResolDeltaThermPvm_1d03_P40,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d03-P50",
    component: ResolDeltaThermPvm_1d03_P50,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d03-P60",
    component: ResolDeltaThermPvm_1d03_P60,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d03-P70",
    component: ResolDeltaThermPvm_1d03_P70,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d03-P80",
    component: ResolDeltaThermPvm_1d03_P80,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm",
    component: ResolDeltaThermPvm_1d03,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltatherm-pvm-1d11-P40",
    component: ResolDeltaThermPvm_1d11_P40,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-fresh-vfs-1d00-p10",
    component: ResolDeltaSolFreshVFS_1d00_P10,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-fwr-2018-2d00-p160",
    component: ResolFwr2018_2d00_P160,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-tt2",
    component: ResolTt2_1d01,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-nemux-sml-v2-3d04",
    component: Tuxhorn_Nemux_SML_V2_3d04,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-nemux-sml-v2-3d05",
    component: Tuxhorn_Nemux_SML_V2_3d05,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-nemux-sml-v2-3d06-p20",
    component: Tuxhorn_Nemux_SML_V2_3d06_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p-4",
    component: TuxhornEthermP_4d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d02",
    component: TuxhornEThermP9Plus_1d02,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d03-P30",
    component: TuxhornEThermP9Plus_1d03_P30,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d03-P50",
    component: TuxhornEThermP9Plus_1d03_P50,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d03-P60",
    component: TuxhornEThermP9Plus_1d03_P60,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d03-P70",
    component: TuxhornEThermP9Plus_1d03_P70,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d03-P80",
    component: TuxhornEThermP9Plus_1d03_P80,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus",
    component: TuxhornEThermP9Plus_1d03,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/tuxhorn-etherm-p9plus-1d11-P40",
    component: TuxhornEThermP9Plus_1d11_P40,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/waterkotte-ecopack",
    component: Waterkotte_EcoPack_2d02,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/viessmann-vitotrans-353-VT2",
    component: ViessmannVitotrans353_VT2_2d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/viessmann-vitotrans-353-VT2-Kaskade",
    component: ViessmannVitotrans353_VT2_2d00_Kaskade,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/Citrin-CS1-3",
    component: Citrin_CS1_3_1d03,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/resol-deltasol-cs-plus-3d00",
    component: ResolDeltaSol_CSPlus_3d00,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P11",
    component: MaxiflameMaxifresh_1d02_P11,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P20",
    component: MaxiflameMaxifresh_1d02_P20,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P30",
    component: MaxiflameMaxifresh_1d02_P30,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P40",
    component: MaxiflameMaxifresh_1d02_P40,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P50",
    component: MaxiflameMaxifresh_1d02_P50,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P60",
    component: MaxiflameMaxifresh_1d02_P60,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/maxiflame-maxifresh-1d02-P70",
    component: MaxiflameMaxifresh_1d02_P70,
    beforeEnter: checkValidSimulationRoute,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
